export enum FetchState {
	START,
	LOADING,
	SUCCESS,
	ERROR,
	WARNING,
}
